<template>
  <div class="app-reset-password-confirmation-wrapper">
    <slot name="txtBefore">
      <h1>Passwort setzen</h1>
    </slot>
    <ResetPasswordConfirmationToken
      v-if="step === 'token'"
      :min-token-length="smsMinTokenLength"
      :max-token-length="smsMaxTokenLength">
      <template v-for="slot in possibleChildSlotsFor('Token')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ResetPasswordConfirmationToken>
    <ResetPasswordConfirmationPassword v-if="step === 'password'">
      <template v-for="slot in possibleChildSlotsFor('Password')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ResetPasswordConfirmationPassword>
    <ResetPasswordConfirmationSuccess
      v-if="step === 'success' "
      :back-button-href="'./login.html'"
    >
      <template #txtBefore>
        <slot name="txtSuccessBefore">
          <p>Gratuliere, Sie haben Ihr neues Passwort gesetzt. Mit einem Klick auf "Zurück" gelangen Sie zum Login
        Ihres Kundenkontos.</p>
        </slot>
      </template>
      <template #btnSuccessBack><slot name="btnSuccessBack"></slot></template>
      <template #txtAfter><slot name="txtSuccessAfter"></slot></template>
    </ResetPasswordConfirmationSuccess>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import ResetPasswordConfirmationToken from './Token.vue'
import ResetPasswordConfirmationPassword from '../Password.vue'
import ResetPasswordConfirmationSuccess from '../../../../../generic/Success2.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
export default {
  name: 'ResetPasswordConfirmationWrapper',
  mixins: [
    transaction('resetPasswordConfirmation'),
    slotProxy()
  ],
  components: { ResetPasswordConfirmationSuccess, ResetPasswordConfirmationPassword, ResetPasswordConfirmationToken },
  mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    this.captureToken(urlParameters.get('token'))
  },
  methods: {
    ...mapMutations('resetPassword', [
      'captureToken'
    ])
  },
  computed: {
    ...mapGetters('resetPassword', [
      'step'
    ])
  },
  props: {
    smsMinTokenLength: {
      type: Number,
      default: 6
    },
    smsMaxTokenLength: {
      type: Number,
      default: 8
    }
  }
}
</script>
